import React from 'react';
import { motion } from 'framer-motion';
import { AreaPlate } from './CadDrawings';

const serviceCategories = [
  {
    id: 'digital',
    kicker: 'Foglio 01',
    title: 'Digital & Tech',
    description: 'Siti, e-commerce, webapp e gestione continua. Il digitale che usi ogni giorno, tenuto in ordine.',
    services: [
      'Siti web & e-commerce',
      'Gestione mensile del sito',
      'WebApp su misura',
      'App mobile',
    ],
  },
  {
    id: 'hospitality',
    kicker: 'Foglio 02',
    featured: true,
    title: 'Case vacanze',
    description: 'Landing, automazioni e flussi per chi affitta: dal calendario alle richieste, senza tre tool diversi.',
    services: [
      'Landing e sito per la struttura',
      'Automazione messaggi e prenotazioni',
      'Calendario e disponibilità',
      'Check-in e check-out',
      'Richieste e preventivi automatici',
    ],
  },
  {
    id: 'marketing',
    kicker: 'Foglio 03',
    title: 'Growth & Marketing',
    description: 'Per acquisizione e crescita clienti.',
    services: [
      'SEO & SEM',
      'Social Media Management',
      'Performance Marketing',
      'Brand Identity',
    ],
  },
  {
    id: 'ai',
    kicker: 'Foglio 04',
    title: 'AI & Automazione',
    description: 'Progettiamo soluzioni di Intelligenza Artificiale e automazione pensate per migliorare processi reali di business.',
    services: [
      'Assistenti AI e chatbot personalizzati',
      'Automazione dei workflow aziendali',
      'Analisi e interpretazione dei dati',
      'Integrazione tra software e sistemi tramite API',
    ],
  },
  {
    id: 'business',
    kicker: 'Foglio 05',
    title: 'Business & Legale',
    description: 'Supporto integrato per costituzione, fiscalità e tutela legale del tuo business.',
    services: [
      'Costituzione Società & Startup',
      'Fiscalità & Contabilità',
      'Contratti & IP',
      'Business Plan',
    ],
  },
  {
    id: 'tenders',
    kicker: 'Foglio 06',
    title: 'Gare e Appalti',
    description: 'Partecipa con successo alle gare pubbliche: dalla ricerca bandi alla presentazione dell’offerta.',
    services: [
      'Ricerca e monitoraggio gare su misura',
      'Analisi requisiti e fattibilità',
      'Iscrizione piattaforme (MEPA, Sintel, START)',
      'Preparazione documentazione amministrativa',
      'Supporto caricamento offerta telematica',
      'Affiancamento continuativo',
    ],
  },
];

const SmartServices = () => {
  return (
    <section id="servizi" className="cad-section">
      <p className="cad-kicker">04 · SERVIZI</p>
      <h2>L’ecosistema Tre Lune</h2>
      <p>
        Sei aree, un solo team. Parti da dove ti serve oggi — sito, case vacanze, crescita, AI, legale o gare — e scala senza cambiare fornitore.
      </p>

      <div className="cad-cards cad-cards-6">
        {serviceCategories.map((cat, index) => (
          <motion.article
            key={cat.id}
            className={cat.featured ? 'is-open' : undefined}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: index * 0.05 }}
          >
            <div className="cad-area-plate">
              <AreaPlate kind={cat.id} />
            </div>
            <div className="cad-area-body">
              <span>{cat.kicker}</span>
              <h3>{cat.title}</h3>
              <p>{cat.description}</p>
              <ul>
                {cat.services.map((s) => (
                  <li key={s}>{s}</li>
                ))}
              </ul>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
};

export default SmartServices;
